import { redirect } from 'react-router-dom';
import notificationGlobal from '../../../Components/Global/NotificationGlobal'
import config from '../../../config'
import socket from '../../../App/socket'
import {
    ERROR_USER_LOGIN, 
    SAVE_DATA_USER_LOGIN,
    LOADING_USER_LOGIN,
    STATUS_MENU_OPEN,
    DATA_PERMISSIONS_USER,
    EMAIL_AZURE,
    GET_DATA_COUNTRIES_LOGIN,
    TIME_SCROLL,
    OPEN_CHROME_MODAL_STATE
} from '../../../Constants/LoginGrow/LoginGrow'
import { RegisterAuditReducer } from '../Audits/Audits'
import { GetAudioGreetingReducer } from '../Preload/Preload'
import { GetDataMenuReducer } from '../GetData/Menu/Menu'
import { notification } from 'antd'

const notificacionServidor = (type, mensaje) => {
    if(type === 'success'){
        notification['success']({
            message: 'Éxito',
            description: mensaje,
        })
    }else if(type === 'warning'){
        notification['warning']({
            message: 'Advertencia',
            description: mensaje,
        })
    }else if(type === 'error'){
        notification['error']({
            message: 'Error',
            description: mensaje,
        })
    }
}

export const LoginUsuarioLoginGrowReducer = (usu) => async (dispatch) => {
    dispatch({
        type: LOADING_USER_LOGIN,
        payload: true
    });

    const maxIntentos = 3;
    const tiempoBloqueo = 60000; // 1 minuto en milisegundos

    // Obtener valores almacenados
    let intentosFallidos = parseInt(localStorage.getItem('intentosFallidos')) || 0;
    let ultimoIntentoFallido = parseInt(localStorage.getItem('ultimoIntentoFallido')) || 0;
    let ahora = Date.now();

    // ⚠️ Verificar si el tiempo de bloqueo ha pasado y restablecer intentos
    if ((ahora - ultimoIntentoFallido) > tiempoBloqueo) {
        intentosFallidos = 0;
        localStorage.setItem('intentosFallidos', '0');
        localStorage.removeItem('ultimoIntentoFallido');
    }

    // 🚨 Si el usuario está bloqueado, no permitir el login
    if (intentosFallidos >= maxIntentos) {
        notificationGlobal('error', 'Has excedido el número de intentos. Intenta nuevamente en 1 minuto.');
        dispatch({
            type: LOADING_USER_LOGIN,
            payload: false
        });
        return false;
    }

    let respuesta = false;

    await fetch(config.api_public + 'login', {
        mode: 'cors',
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json',
        },
        body: JSON.stringify(usu),
    })
    .then(res => res.json())
    .then(async data => {
        if (data.respuesta) {
            // ✅ Login exitoso → resetear intentos fallidos
            respuesta = true;
            localStorage.setItem('usutoken', data.auth_token);
            localStorage.setItem('usupais', usu.req_paiid);
            
            dispatch({
                type: SAVE_DATA_USER_LOGIN,
                payload: data.user
            });

            const nameUser = data.user.perpersonas.pernombre;
            const nameFirst = nameUser.split(" ");

            socket.emit('reg-login', data.user);

            localStorage.setItem('usuusuario', nameFirst ? nameFirst[0] : "");

            dispatch({
                type: DATA_PERMISSIONS_USER,
                payload: data.user.permisos
            });

            dispatch({
                type: ERROR_USER_LOGIN,
                payload: {}
            });

            dispatch(GetDataMenuReducer());
            dispatch(ChangeTimeScroll(true));
            const urlAudio = await dispatch(GetAudioGreetingReducer());
            const newAudio = new Audio(urlAudio);
            newAudio.play();
            localStorage.removeItem("pairestore");

            // 🔄 Reiniciar intentos fallidos después de un inicio de sesión exitoso
            localStorage.setItem('intentosFallidos', '0');
            localStorage.removeItem('ultimoIntentoFallido');

        } else {
            // ❌ Fallo de login → aumentar intentos fallidos
            intentosFallidos++;
            localStorage.setItem('intentosFallidos', intentosFallidos.toString());
            localStorage.setItem('ultimoIntentoFallido', Date.now().toString());

            const intentosRestantes = maxIntentos - intentosFallidos;

            if (intentosFallidos >= maxIntentos) {
                notificationGlobal('error', 'Has excedido el número de intentos. Intenta nuevamente en 1 minuto.');
            } else {
                notificationGlobal('warning', `Credenciales incorrectas. Te quedan ${intentosRestantes} intento(s) restante(s).`);
            }

            if (data.alert) {
                dispatch({
                    type: ERROR_USER_LOGIN,
                    payload: data.alert
                });
            }

            const json_audit = {
                url: 'login',
                ip: '',
                json_input: usu,
                json_output: data,
                description: data.message,
                message: data.message,
                action: "LOGIN",
                route: "/login-grow",
                status: false,
                module: "Login Grow"
            };
            dispatch(RegisterAuditReducer(json_audit));
        }
    })
    .catch((error) => {
        notificationGlobal('warning', 'Ha ocurrido un error en el servidor');
        console.log(error);
    });

    dispatch({
        type: LOADING_USER_LOGIN,
        payload: false
    });

    dispatch({
        type: OPEN_CHROME_MODAL_STATE,
        payload : true
    })

    if(localStorage.getItem('presentation')){
        setTimeout(() => {
            localStorage.removeItem('presentation');
        }, 4000);
    } else {
        setTimeout(() => {
            localStorage.setItem('presentation', true);
        }, 4000);
    }

    return respuesta;
};



export const CloseOpenChromeModalReducer = () => async ( dispatch, getState ) => {

    dispatch({
        type : OPEN_CHROME_MODAL_STATE,
        payload : false
    })
}

export const StatusMenuOpenReducer =  ( open ) => async ( dispatch ) => {
    dispatch({
        type : STATUS_MENU_OPEN,
        value : open
    })
}

export const RecoverPasswordLoginGrowReducer = (usucorreo) => async ( dispatch ) => {
    let respuesta   = false
    let message     = ""

    let paiid = localStorage.getItem('pairestore')

    if(!paiid){
        paiid = 1
    }

    await fetch(config.api_public+'request-password',
        {
            mode:'cors',
            method: 'POST',
            headers: {
                'Accept' 	   : 'application/json',
                'Content-type' : 'application/json',
            },
            body: JSON.stringify({
                req_usucorreo   : usucorreo,
                req_paiid       : paiid
            }),
        }
    )
    .then(res => res.json())
    .then(async data => {
        if(data.response){
            respuesta = true
        }
        message = data.message
    }).catch((error)=> {
        notificationGlobal('warning', 'Ha ocurrido un error en el servidor')
        console.log(error)
    })

    return {respuesta, message}
}

export const RestorePasswordLoginGrowReducer = (token, password, paiid) => async ( dispatch ) => {

    let respuesta   = false
    let message     = false
    
    await fetch(config.api_public+'restore-password',
        {
            mode:'cors',
            method: 'POST',
            headers: {
                'Accept' 	   : 'application/json',
                'Content-type' : 'application/json',
                'usutoken'      : token
            },
            body: JSON.stringify({
                req_password : password,
            }),
        }
    )
    .then(res => res.json())
    .then(async data => {
        if(data.response){
            respuesta = true
            socket.emit('logout', data.usucorreo);
            let responseLogin = await dispatch(LoginUsuarioLoginGrowReducer({req_usucorreo: data.usucorreo, req_usucontrasenia: password, req_paiid: parseInt(paiid)}))
            if(responseLogin){
                respuesta = true
            }
        }else{
            message = data.message
        }
    }).catch((error)=> {
        notificationGlobal('warning', 'Ha ocurrido un error en el servidor')
        console.log(error)
    })

    return { respuesta, message }
}

export const FindUserAzureReducer = (user_correo) => async () => {
    let response = false
    await fetch(config.api_public+'validate-email-azure',
        {
            mode:'cors',
            method: 'POST',
            headers: {
                'Accept' : 'application/json',
                'Content-type' : 'application/json',
            },
            body: JSON.stringify({
                req_usuusuario: user_correo,
            }),
        }
    )
    .then(res => res.json())
    .then(data => {
        response = data.response
        if(!data.response){
            notificacionServidor('warning', data.message)
        }
    }).catch((error)=> {
        console.log(error)
    })

    return response
}

export const ChangeEmailAzureReducer = (value) => async (dispatch) => {
    dispatch({
        type : EMAIL_AZURE,
        payload : value
    })
}

export const LoginUsuarioAzureLoginGrowReducer = (token) => async ( dispatch ) => {
    let respuesta = false
    
    await fetch(config.api_public+'validate-login-token',
        {
            mode:'cors',
            method: 'POST',
            headers: {
                'Accept' 	   : 'application/json',
                'Content-type' : 'application/json',
            },
            body: JSON.stringify({
                req_token: token
            }),
        }
    )
    .then(res => res.json())
    .then(async data => {
        if(data.respuesta){
            respuesta = true
            localStorage.setItem('usutoken', data.auth_token)
            localStorage.setItem('usupais', data.user.countries_usu[0])

            dispatch({
                type: SAVE_DATA_USER_LOGIN,
                payload : data.user
            })

            const nameUser = data.user.perpersonas.pernombre
            const nameFirst = nameUser.split(" ")

            socket.emit('reg-login', data.user);

            localStorage.setItem('usuusuario', nameFirst ? nameFirst[0] : "")
            
            dispatch({
                type    : DATA_PERMISSIONS_USER,
                payload : data.user.permisos
            })

            dispatch({
                type: ERROR_USER_LOGIN,
                payload : {}
            })
            
            dispatch(GetDataMenuReducer())
            const urlAudio = await dispatch(GetAudioGreetingReducer())
            const newAudio = new Audio(urlAudio)
            newAudio.play()
            localStorage.removeItem("pairestore");
        }else{
            const json_audit = {
                url : 'login',
                ip : '',
                json_input  : { req_token: token },
                json_output : data,
                description : data.message,
                message     : data.message,
                action      : "LOGIN AZURE",
                route       : "/login",
                status      : false,
                module      : "Login"
            }
            dispatch(RegisterAuditReducer(json_audit))
        }
    }).catch((error)=> {
        notificationGlobal('warning', 'Ha ocurrido un error en el servidor')
        console.log(error)
    })

    if(localStorage.getItem('presentation')){
        setTimeout(() => {
            localStorage.removeItem('presentation')
        }, 4000)
    }else{
        setTimeout(() => {
            localStorage.setItem('presentation', true)
        }, 4000)
    }

    return respuesta
}

export const GetCountriesLoginReducer = () => async (dispatch) => {
    await fetch(config.api_public+'get-data-countries-login',
        {
            mode:'cors',
            method: 'GET',
            headers: {
                'Accept' 	   : 'application/json',
                'Content-type' : 'application/json',
            },
        }
    )
    .then(res => res.json())
    .then(async data => {
        if(data.response){
            dispatch({
                type : GET_DATA_COUNTRIES_LOGIN,
                payload : data.data
            })
        }else{
            // notificationGlobal('warning', data.message)
        }
    }).catch((error)=> {
        // notificationGlobal('warning', 'Ha ocurrido un error en el servidor')
        console.log(error)
    })
}

export const ChangeTimeScroll = (value) => async (dispatch) => {
    dispatch({
        type : TIME_SCROLL,
        payload : value
    })
}